import { IAdditionalSettings } from "@/config/additionalSettings.config";

const greeceAdditionalSettingsConfig: IAdditionalSettings = {
  hasGoldenVisa: true,
};

export default greeceAdditionalSettingsConfig;
